import React, { useEffect } from 'react';
import { message } from 'antd';
import { usePatientStore, useUnifiedDashboardStore } from '../store';
import PatientTable from './Table/PatientTable';
import HistoryPage from './HistoryPage';
import ModalService from './Modal/ModalService';
import RealtimeWaitingRoom from './RealtimeWaitingRoom';
import { UnifiedDashboard, MonitorPage } from './UnifiedDashboard';
import { FEATURE_FLAGS } from '../constants';

const PSOPanel = ({ userInfo, currentView }) => {
  const [messageApi, messagePlaceholder] = message.useMessage();

  const { isFetchingPatientsError } = usePatientStore((state) => ({
    isFetchingPatientsError: state.isFetchingPatientsError,
  }));

  const { fetchUnifiedData, startAutoRefresh, stopAutoRefresh } =
    useUnifiedDashboardStore();

  // Fetch data once and keep auto-refresh running across tab switches
  useEffect(() => {
    if (!FEATURE_FLAGS.useUnifiedDashboard) return;

    fetchUnifiedData();
    startAutoRefresh(60000);

    return () => {
      stopAutoRefresh();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderContent = () => {
    if (currentView === 'history') {
      return <HistoryPage userInfo={userInfo} messageApi={messageApi} />;
    }

    if (currentView === 'videoroom') {
      return <MonitorPage />;
    }

    // Default to main view
    // Use feature flag to switch between new Unified Dashboard and legacy UI
    if (FEATURE_FLAGS.useUnifiedDashboard) {
      return <UnifiedDashboard />;
    }

    // Legacy UI (Active Calls + Waiting Room)
    return (
      <>
        <RealtimeWaitingRoom />
        <PatientTable userInfo={userInfo} messageApi={messageApi} />
      </>
    );
  };

  return (
    <>
      {messagePlaceholder}
      {isFetchingPatientsError ? (
        <div>
          Error: Failed to get call information, please try again or contact our
          technical support.
        </div>
      ) : (
        <>
          <ModalService messageApi={messageApi} />
          {renderContent()}
        </>
      )}
    </>
  );
};

export default PSOPanel;
